import { UnderMaintenance } from '@/components/ui';

export const ReportActivity = () => {
    return <UnderMaintenance />;
};

ReportActivity.displayName = 'ReportActivity';
